import { createReducer, on } from '@ngrx/store'
import * as WithClientsActions from '../linking-with-clients/with-clients.actions'
import { HandlerState } from './handler.state'

export const initialState: HandlerState = {
   showSpinner: false,
}

export const handlerReducer = createReducer(
   initialState,
   on(WithClientsActions.getWithClientsDetailByID, (state) => ({
      ...state,
      showSpinner: true,
   })),
   on(WithClientsActions.getWithClientsDetailByIDSuccess, WithClientsActions.getWithClientsDetailByIDFailure, (state) => ({ ...state, showSpinner: false }))
)
